import * as S from "../styles";
import GoogleSchools from "./GoogleSchools";
import MapGLSchools from "./MapGLSchools";
import { LoadingItem } from "@local-logic/core/ui";
import React from "react";
import { useStateManagerContext } from "~/context/stateManager";
import { useSchools } from "~/sdks/LocalContent/features/useSchools";
import { LocalContentProps } from "~/sdks/LocalContent/types";

interface SchoolsProps {
  score: "primary_schools" | "high_schools";
}

const Schools = ({ score }: SchoolsProps) => {
  const { isLoading } = useSchools();
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  const isGoogleMapProvider = sdkState.options?.mapProvider === "google";

  if (isLoading) {
    return (
      <>
        {[...Array(10)].map((_, i) => (
          <S.LoadingItemContainer key={i}>
            <LoadingItem height="34px" width="100%" />
          </S.LoadingItemContainer>
        ))}
      </>
    );
  }

  return isGoogleMapProvider ? (
    <GoogleSchools score={score} />
  ) : (
    <MapGLSchools score={score} />
  );
};

export default Schools;
